import { SmileOutlined } from '@ant-design/icons';
import { Form, Input } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import { useTranslation } from 'react-i18next';
import { ModalButtons } from '../MyDayPage/ModalButtons';
import { handleSignup } from './handleSignup';
import { openNotification } from './openNotification';

export const SignupModal = ({ show, onCancel }: { show: boolean; onCancel: () => void }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  if (!show) return <></>;
  return (
    <Modal
      open={show}
      title={t('auth.signupTitle')}
      okText={t('common.add')}
      styles={{ body: { padding: 0, borderRadius: '20px' } }}
      cancelText={t('common.cancel')}
      className="modalStyle"
      onCancel={onCancel}
      footer={null}
      onOk={() => console.log('Validate Failed:')}
    >
      <Form form={form} layout="vertical" name="form_in_modal_create_agent" initialValues={{}}>
        <div className="signup-container">
          <div className="create-user-firstname">
            <Form.Item label={<p className="styled-label">{t('auth.firstName')}</p>} name="firstname">
              <Input.TextArea className="styled-text-input" />
            </Form.Item>
          </div>
          <div className="create-user-lastname">
            <Form.Item label={<p className="styled-label">{t('auth.lastName')}</p>} name="lastname">
              <Input.TextArea className="styled-text-input" />
            </Form.Item>
          </div>
          <div className="create-user-hour-rate">
            <Form.Item label={<p className="styled-label">{t('auth.hourRate')}</p>} name="hourRate">
              <Input className="styled-text-input" type="number" />
            </Form.Item>
          </div>
          <div className="create-user-email">
            <Form.Item
              rules={[
                {
                  required: true,
                  type: 'email',
                  message: t('auth.pleaseInputValidEmail'),
                },
              ]}
              label={<p className="styled-label">{t('auth.emailAddress')}</p>}
              name="email"
            >
              <Input className="styled-text-input" />
            </Form.Item>
          </div>
          <div className="create-user-password">
            <Form.Item
              rules={[
                {
                  required: true,
                  message: t('auth.pleaseInputPasswordSignup'),
                },
              ]}
              label={<p className="styled-label">{t('auth.password')}</p>}
              name="password"
            >
              <Input.Password className="styled-text-input" />
            </Form.Item>
          </div>

          <ModalButtons
            onOk={() => {
              form
                .validateFields()
                .then((values) => {
                  const vals = {
                    ...values,
                    username: values.email,
                    role: 'USER',
                  };
                  handleSignup(vals)
                    .then(() => {
                      openNotification('Success', t('auth.signupSuccessful'), <SmileOutlined />);
                      form.resetFields();
                      onCancel(); // Close the modal
                      // Delay reload to allow notification to be visible
                      setTimeout(() => {
                        window.location.reload();
                      }, 1500);
                    })
                    .catch((error) => {
                      // Error notification is already shown in handleSignup
                      console.error('Signup failed:', error);
                    });
                })
                .catch((info) => {
                  console.log('Validate Failed:', info);
                });
            }}
            onCancel={onCancel}
            okText={t('auth.signup')}
          />
        </div>
      </Form>
    </Modal>
  );
};
